<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
    <path
      d="M16.65 0C7.45 0 0 7.46667 0 16.6667C0 25.8667 7.45 33.3333 16.65 33.3333C25.8667 33.3333 33.3333 25.8667 33.3333 16.6667C33.3333 7.46667 25.8667 0 16.65 0ZM23.3333 23.3333C22.6833 23.9833 21.6333 23.9833 20.9833 23.3333L15.5 17.85C15.1833 17.5333 15 17.1167 15 16.6667V10C15 9.08333 15.75 8.33333 16.6667 8.33333C17.5833 8.33333 18.3333 9.08333 18.3333 10V15.9833L23.3333 20.9833C23.9833 21.6333 23.9833 22.6833 23.3333 23.3333Z"
      fill="url(#paint0_linear_263_152)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_263_152"
        x1="0"
        y1="0"
        x2="33.4467"
        y2="33.2191"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
